import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { WithContext as ReactTags } from 'react-tag-input';
import SimplePagination from "./SimplePagination";
import ProviderInformationCard from "./ProviderInformationCard";
import { LangContext } from "../LangContext.jsx";
class ShareDocuments extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            personProvider:[],
            expiredTotalfiles:[],
            approvedTotalfiles:[],
            valid:true,
            allfiles:false,
            selectedUser:[],
            edit:false,
            maxRecords: 5,
            select:false,
            approved:[],
            approvedFiles:[],
            sharedUsers:[],
            expiredFiles:[],
            approvedCheckedFiles: [],
            approvedPage:1,
            expired:[],
            expiredCheckedFiles: [],
            expiredPage:1,
            approvedTotal:0,
            expiredTotal:0,
            tags: [
            ],
            delimiters:[188, 13]
        }; 
    }

    updateCurrentApprovedPage = (page) =>{
        this.setState({approvedPage: page}, function () {
            this.getApprovedFiles();
        });
    }

    editUser = (user)=>{
        this.setState({select: true})
        this.setState({selectedUser: user})
        this.setState({edit: true});
        (user.all_files == 1 ?  this.setState({allfiles: true}) :  this.setState({allfiles: false}))
        this.getApprovedFiles()
        this.getExpiredFiles()
    }

    updateCurrentExpiredPage = (page) =>{
        this.setState({expiredPage: page}, function () {
            this.getExpiredFiles();
        });
    }
    getUserData = (user)=>{
        let newArray = [];
        user.files.map(file=>{
            if (this.state.approvedFiles.includes(file)) {
                newArray = newArray.filter(filed => filed !== file.id );
            }
        })
        this.setState({ approvedCheckedFiles: newArray } );
    }
    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getAditionalDocuments();
        });
    }

    handleDelete = (i)=>{
        this.setState({tags: this.state.tags.filter((tag, index) => index !== i)},function(){
            (this.state.tags.length > 0 && (this.state.approvedCheckedFiles.length > 0 || this.state.expiredCheckedFiles.length > 0 ) ?
            this.setState({ valid: false }) :
            this.setState({ valid: true }) )
        })
    }

    emailValidation(email){
        const regex =/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if( regex.test(email) === false){

            return false;
        }
        return true;
    }

    handleAddition = async (i)=>{
        const lang = this.context.lang; 
        if(this.emailValidation(i.text) == false){
            swal.fire({
                text: 'Debes ingresar un correo válido',
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
            return false;
        }

        await axios.post('/api/shared_dossiers/shared_user',{user:i,person_provider_id:this.props.person_provider_id}).then(res=>{
            if(res.data == 1){
                swal.fire({
                    text:lang.get('messages.este_correo_ya_tiene_documentos_compartidos'),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: lang.get('messages.aceptar'),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    }
                });
                return false
            }else{
                this.setState(previousState => ({
                    tags: [...previousState.tags, i]
                }),function(){
                    (this.state.tags.length > 0 && (this.state.approvedCheckedFiles.length > 0 || this.state.expiredCheckedFiles.length > 0 ) ? this.setState({ valid: false }) : this.setState({ valid: true }) );
                    if(this.state.allfiles == true){
                        (this.state.allfiles == true ? this.setState({ valid: false }) : this.setState({ valid: true }));
                    }
                });
            }
        })
    }

    selectAllFiles = (e)=>{
        if(e.target.checked == true){
            let approved = this.state.approved.map(file=>{
                return file.id
            })
            let expired = this.state.expired.map(file=>{
                return file.id
            })
            this.setState({approvedCheckedFiles: approved})
            this.setState({expiredCheckedFiles: expired})
            this.setState({select: true})
            if(this.state.edit == true){
                this.setState({ valid: false });
            }else{
                if(this.state.tags.length > 0){
                    this.setState({ valid: false });
                }
            }
        }
        if(e.target.checked == false){
            this.setState({ valid: true });
            this.setState({approvedCheckedFiles:[]})
            this.setState({expiredCheckedFiles:[]})
        }
        this.setState({
            allfiles: e.target.checked
        });
    }

    getData = () =>{
        let data = {
            'id':this.props.person_provider_id, 
        }
        axios.post('/api/shared_dossiers/data',data).then(res=>{
                this.setState({sharedUsers: res.data.sharedUsers})
            })
    } 
    componentDidMount() {  
        
        this.getData()
        this.getApprovedFiles()
        this.getExpiredFiles()
        $('#shareModal').modal('show')
        const handleDrag = (tag, currPos, newPos) => {
            const newTags = tags.slice();
            newTags.splice(currPos, 1);
            newTags.splice(newPos, 0, tag);
            setTags(newTags);
        };
    }

    copyLink = (link) => {
        navigator.clipboard.writeText(link);
        toastr.info("Link copiado");
    }

    handleCheckboxEditChange = (id)=>{
        let newArray = [...this.state.approvedCheckedFiles, id];
        if (this.state.approvedCheckedFiles.includes(id)) {
            newArray = newArray.filter(file => file !== id );
        }
        this.setState({ approvedCheckedFiles: newArray } );
    }

    getExpiredFiles = () =>{
        const query = new URLSearchParams();
        query.append('page', this.state.expiredPage)
        query.append('maxRecords', this.state.maxRecords)
        query.append('is_internal',this.props.is_internal)
        const qs = query.toString();
        axios.get('/api/shared_dossiers/expired/'+this.props.person_provider_id+ '/'+`?${qs}`).then(res=>{
            this.setState({expiredTotalfiles: res.data.total})
            console.log(res.data.files.data)
            this.setState({expired: res.data.files.data } ,function(){
                let userFiles = []
                if(this.state.edit == true){
                    this.state.selectedUser.files.map(file=>{
                        userFiles.push(file.document.id.toString())
                        this.handleCheckboxEditChange(file.file_id)
                    })
                    this.setState({approvedTotal: res.data.files.total})
                    this.setState({approvedCheckedFiles: userFiles})
                    this.setState({expiredCheckedFiles: userFiles})
                }
            })
            this.setState({expiredTotal: res.data.files.total})
        });
    }

    getApprovedFiles = () =>{
        const query = new URLSearchParams();
        query.append('page', this.state.approvedPage)
        query.append('maxRecords', this.state.maxRecords) 
        const qs = query.toString();
        axios.get('/api/shared_dossiers/approved/'+this.props.person_provider_id+ '/'+`?${qs}`).then(res=>{
            this.setState({approvedTotalfiles: res.data.total})
            this.setState({approved: res.data.files.data},function(){
                let userFiles = []
                if(this.state.edit == true){
                    this.state.selectedUser.files.map(file=>{
                        userFiles.push(file.document.id.toString())
                        this.handleCheckboxEditChange(file.file_id)
                    })
                    this.setState({approvedCheckedFiles: userFiles})
                    this.setState({expiredCheckedFiles: userFiles})
                }
            })
            this.setState({approvedTotal: res.data.files.total})
        });
    }

    handleChange(tags) {
        this.setState({tags})
    }
    back = ()=>{
        this.setState({select: false})
        this.setState({edit: false})
    }
    save = ()=>{
        const lang = this.context.lang;  
        let files = this.state.approvedTotalfiles.filter((file)=>{
            for (let i = 0; i < this.state.approvedCheckedFiles.length; i++) {
                if(file.id == this.state.approvedCheckedFiles[i]){
                    return file
                }
            }
        })

        let expired = this.state.expiredTotalfiles.filter((file)=>{
            for (let i = 0; i < this.state.expiredCheckedFiles.length; i++) {
                if(file.id == this.state.expiredCheckedFiles[i]){
                    return file
                }
            }
        })

        if(this.state.edit == true){
            window.blockUI();
            let data = {
                person_provider_id:this.props.person_provider_id,
                dossier_id:this.props.dossier_id,
                user:this.state.selectedUser,
                approvedFiles:files,
                expiredFiles:expired,
                allfiles:this.state.allfiles,
                is_internal:this.props.is_internal
            }
            axios.post('/api/shared_dossiers/'+this.props.person_provider_id+ '/update',data).then(res=>{
                window.unblockUI();
                swal.fire({
                    text: lang.get('messages.guardado'),
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText:  lang.get('messages.aceptar'),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    },
                    timer: 3000
                }).then(function(result) {
                    location.reload()
                });
            });
        }else{
            window.blockUI();
            let data = {
                person_provider_id:this.props.person_provider_id,
                dossier_id:this.props.dossier_id,
                emails:this.state.tags,
                approvedFiles:files,
                expiredFiles:expired,
                allfiles:this.state.allfiles,
                is_internal:this.props.is_internal
            }
            axios.post('/api/shared_dossiers/'+this.props.person_provider_id+ '/store',data).then(res=>{
                window.unblockUI();
                swal.fire({
                    text:lang.get('messages.guardado'),
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText:  lang.get('messages.aceptar'),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    },
                    timer: 3000
                }).then(function(result) {
                    location.reload()
                });
            });
        }
    }

    handleCheckboxChange = (e)=>{
        let newArray = [...this.state.approvedCheckedFiles, e.target.id];
        if (this.state.approvedCheckedFiles.includes(e.target.id)) {
            newArray = newArray.filter(file => file !== e.target.id );
        }
        if(this.state.edit == true){
            (newArray.length > 0 ? this.setState({ valid: false } ) : this.setState({ valid: true } ))
        }else{
            (newArray.length > 0 && this.state.tags.length > 0 ? this.setState({ valid: false } ) : this.setState({ valid: true } ))
        }
        this.setState({ approvedCheckedFiles: newArray } );
    }

    deleteSharedDossier = (id)=>{
        const lang = this.context.lang; 
        swal.fire({
            text: lang.get('messages.estas_seguro_que_deseas_eliminar_el_acceso_al_documento'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.delete(id);
            }
        });
    }

    delete = (id)=>{
        const lang = this.context.lang; 
        axios.delete('/api/shared_dossiers/delete/'+id).then(res=>{
            swal.fire({
                text: lang.get('messages.expediente_eliminado'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText:  lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).
            then(function(result) {
                location.reload()
            });
        })
    }
    
    handleCheckboxExpiredChange = (e)=>{
        let newArray = [...this.state.expiredCheckedFiles, e.target.id];
        if (this.state.expiredCheckedFiles.includes(e.target.id)) {
            newArray = newArray.filter(file => file !== e.target.id );
        }
        if(this.state.edit == true){
            (newArray.length > 0 ? this.setState({ valid: false } ) : this.setState({ valid: true } ))
        }else{
            (newArray.length > 0 && this.state.tags.length > 0 ? this.setState({ valid: false } ) : this.setState({ valid: true } ))
        }
        this.setState({ expiredCheckedFiles: newArray } );
    }

    addUsers = ()=>{
        this.setState({select: true},function(){
            $('.users_selector').select2();
        })
    }

    render() {
        const { lang } = this.context; 
        return (
            <>
            <div className="modal fade" id="shareModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
     
                    {(this.state.approved.length == 0 && this.state.expired.length == 0) &&
                        <div className="modal-content modal-content-alert p-20 text-muted text-center"  >
                            <span className="flaticon2-warning mb-2 icon-5x text-warning"></span>
                            <h4>
                                    {lang.get('messages.es_necesario_que_los_expedientes_cuenten_con_documentos_aprobados_o_en_el_historial_para_que_puedas_realizar_esta_accion')}
                            </h4>
                            <div>
                                <button type="button" className="btn btn-primary mt-3" data-dismiss="modal"> { lang.get('messages.aceptar')} </button>
                            </div>
                        </div>
                    }
                    {(this.state.approved.length > 0 || this.state.expired.length > 0) &&
                    <div className="modal-content"  >
                        <div className="modal-body px-15 py-10"><h5 className="text-dark font-weight-bold my-1 mr-5">{lang.get('messages.compartir_documentos')}</h5>
                        <ProviderInformationCard person_provider_id={this.props.person_provider_id} />
                            <div className="card card-custom gutter-b my-5">
                                <div className="card-body pt-5">
                                    {this.state.select == false &&
                                        <>
                                        {this.state.sharedUsers.length == 0 &&
                                            <div className="d-flex flex-column notShared align-items-center">
                                                <b>{lang.get('messages.este_expediente_aun_no_ha_sido_compartido')}</b>
                                                <button onClick={ ()=> {this.addUsers() } } className="btn btn-primary mt-3">
                                                    <i className="flaticon-user-add"></i>
                                                    {lang.get('messages.agregar_personas')}
                                                </button>
                                            </div>
                                        }
                                        {this.state.sharedUsers.length > 0 &&
                                            <>
                                            <div className="d-flex justify-content-between align-items-end mb-8">
                                                <b> {lang.get('messages.listado_de_personal_con_acceso_a_los_documentos_del_expediente')}</b>
                                                <button onClick={ ()=> {this.addUsers() } } className="btn btn-primary mt-3">
                                                <i className="flaticon-user-add"></i>
                                                    {lang.get('messages.agregar_personas')}</button>
                                                </div>
                                                <div className="d-flex flex-column shared">
                                                <div>
                                                    <table className="table table-borderless">
                                                { this.state.sharedUsers.map((u, i) => {
                                                    return <tr>
                                                        <td className="text-center">
                                                            {u.user_id  != null &&
                                                                <img src="/assets/img/icons/exppedify.svg" style={{width:'20px'}}/>
                                                            }
                                                            {u.user_id  == null &&
                                                                <i className="flaticon-avatar text-primary"></i>
                                                            }
                                                        </td>
                                                        <td>
                                                            {u.user  != null &&
                                                                u.user.email
                                                            }
                                                            {u.email}
                                                            {u.all_files == 1 &&
                                                            <>
                                                            ( {lang.get('messages.todos_los_documentos')} )
                                                            </>
                                                            }
                                                            {u.all_files != 1 &&
                                                            <>
                                                            ( {u.approved} {lang.get('messages.documentos_aprobados')}, {u.expired } {lang.get('messages.documentos_del_historial_compartidos')} )
                                                            </>
                                                            }
                                                            <br></br>
                                                            <a href={'/shared_dossier/'+u.path}>{lang.get('messages.ver_expediente')}</a>
                                                            <a title="Copiar" className="ml-4" onClick={() => this.copyLink(this.props.url+'/shared_dossier/'+u.path)}>
                                                                <button className="btn btn-icon btn-light btn-xs">
                                                                <i className={"flaticon2-copy icon-sm text-primary"}></i>
                                                                </button>
                                                            </a>
                                                        </td>
                                                        <td></td>
                                                        <td className="text-right">
                                                            <a onClick={()=>{this.deleteSharedDossier(u.id)} }  className="btn btn-xs btn-icon btn-light-secondary mr-4"><i className="flaticon-delete fw-normal text-primary"></i></a>
                                                            <a href="#" onClick={()=>{this.editUser(u)} } className="btn btn-xs btn-icon btn-light-secondary mr-4"><i className="flaticon2-edit text-primary"></i></a>
                                                            <a href={'/shared_dossier/'+u.path} className="btn btn-xs btn-icon btn-light-secondary mr-4"><i className="flaticon2-right-arrow text-primary icon-sm"></i></a>
                                                        </td>
                                                    </tr>
                                                    })
                                                }
                                                </table>
                                                </div>
                                            </div>
                                            </>
                                        }
                                        </>
                                    }
                                    {(  this.state.edit == true) &&
                                    <h5> {lang.get('messages.editando_usuario')}: {(this.state.selectedUser.email != '' ? this.state.selectedUser.email : this.state.selectedUser.user.email)}
                                    </h5>
                                    }
                                    {(this.state.select == true && this.state.edit == false) &&
                                    <>
                                    <h5>{lang.get('messages.personas_que_tendran_acceso')}</h5>
                                    <p className="text-danger font-size-sm"><i className=" icon-xs flaticon2-information text-danger"></i> {lang.get('messages.para_agregar_un_correo_es_necesario_dar_click_en_enter')}</p>
                                        <ReactTags
                                            classNames={{
                                                tags: 'tagsClass',
                                                tagInput: 'tagInputClass',
                                                tagInputField: 'form-control mt-3',
                                                selected: 'selectedTag',
                                                tag: 'tagClass',
                                                remove: 'removeClass',
                                                suggestions: 'suggestionsClass',
                                                activeSuggestion: 'activeSuggestionClass',
                                                editTagInput: 'editTagInputClass',
                                                editTagInputField: 'editTagInputField',
                                                clearAll: 'clearAllClass',
                                            }}
                                            placeholder={lang.get('messages.ingresa_un_correo_electronico')}
                                            tags={this.state.tags}
                                            id='tags'
                                            delimiters={this.state.delimiters}
                                            handleDelete={ (e)=>{ this.handleDelete(e) } }
                                            handleAddition={  (e)=>{ this.handleAddition(e) }}
                                            handleDrag={this.handleDrag}
                                            handleTagClick={this.handleTagClick}
                                            inputFieldPosition="bottom"
                                            autocomplete
                                        />
                                    </>
                                    }
                                    {(this.state.select == true  ) &&
                                        <>
                                            <div className="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert">
                                                <div>
                                                    <span className="flaticon2-warning mr-2 icon-3x"></span>
                                                </div>
                                                <div>
                                                    <h3>{lang.get('messages.nota')}</h3>
                                                    {lang.get('messages.solo_se_pueden_compartir_documentos_aprobados_y_del_historial')}
                                                </div>
                                            </div>
                                            <div className="card mt-3 p-4">
                                                <div className="d-flex align-items-center gap-1 text-primary">
                                                    <input value={this.state.allfiles} onClick={ e => this.selectAllFiles(e) } type="checkbox" checked={this.state.allfiles} /> <b>{lang.get('messages.seleccionar_todos_los_documentos')} ( {lang.get('messages.aprobados')}, {lang.get('messages.historial')} </b>
                                                </div>
                                                    { this.state.allfiles == false &&
                                                    <>
                                                    <div className="card-header-collapse" id="headingOne">
                                                        <div className="mb-0 d-flex align-items-center">
                                                            <button className="btn btn-block text-left mr-2 text-dark-75 font-weight-bolder font-size-lg"
                                                                    type="button" data-toggle="collapse"
                                                                    data-target={`#aprobados`}
                                                                    onClick={ ()=>{ this.getApprovedFiles() } }
                                                                    aria-expanded="false" aria-controls="collapseOne">
                                                                    <i className="flaticon2-plus mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>
                                                                    <i className="flaticon2-line mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>{lang.get('messages.aprobados')}</button>
                                                            <div className="pr-4 font-weight-bolder">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id={`aprobados`} className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                        <div className="pt-10 pb-10">
                                                        { this.state.approved.length == 0 &&
                                                            <h5 className="text-muted text-center">{lang.get('messages.el_expediente_no_cuenta_con_documentos_aprobados')}</h5>
                                                        }
                                                        { this.state.approved.length > 0 &&
                                                            <table className="table table-borderless m-0 table-valign">
                                                                <thead>
                                                                    <tr>
                                                                        <td colSpan={2}>{lang.get('messages.documento')}</td>
                                                                        <td>{lang.get('messages.formato')}</td>
                                                                        <td>{lang.get('messages.frecuencia')}</td>
                                                                        <td>{lang.get('messages.expiracion')}</td>
                                                                        <td></td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                { this.state.approved.map((d, i) => {
                                                                return <tr key={d.id}>
                                                                        <td><input type="checkbox"  id={d.id}   onChange={e => this.handleCheckboxChange(e)} checked={this.state.approvedCheckedFiles.includes(d.id.toString())}    /></td>
                                                                        <td className="d-flex gap-1" ><img src={"/assets/img/" + window.getMimeSVG(d.file.extension!=undefined && d.file.extension.length>0 ? d.file.extension : d.file.path)}/>
                                                                        <b>{d.file.title}</b>
                                                                        </td>
                                                                        <td>{
                                                                            d.document.mimes.map((mime, i, {length}) => {
                                                                                if (length - 1 === i) {
                                                                                    return mime.mime.toUpperCase()
                                                                                } else {
                                                                                    return mime.mime.toUpperCase() + ', '
                                                                                }
                                                                            })
                                                                        }</td>
                                                                        <td>
                                                                            {d.document.frequency == 'once' &&
                                                                                <b>{lang.get('messages.unico')}</b>
                                                                            }
                                                                            {d.document.frequency != 'once' &&
                                                                                <b>{lang.get('messages.recurrente')}</b>
                                                                            }
                                                                        </td>
                                                                        <td>{ (d.expiration_date != null ? moment(d.expiration_date).format('YYYY-MM-DD') : null)  }</td>
                                                                        <td className="text-right">
                                                                            <a className="btn btn-xs btn-icon btn-light-secondary mr-4"
                                                                                href={"/files/"  }
                                                                                target="_blank" download
                                                                            >
                                                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                })}
                                                                </tbody>
                                                            </table>
                                                            }
                                                            {this.state.approvedTotal > this.state.maxRecords  &&
                                                            <SimplePagination
                                                                    updateCurrentPage={this.updateCurrentApprovedPage}
                                                                    currentPage={this.state.approvedPage}
                                                                    totalFiles={this.state.approvedTotal}
                                                                    split={this.state.maxRecords} />}
                                                        </div>
                                                    </div>
                                                    <div className="mb-0 d-flex align-items-center">
                                                            <button className="btn btn-block text-left mr-2 text-dark-75 font-weight-bolder font-size-lg"
                                                                    type="button" data-toggle="collapse"
                                                                    data-target={`#caducos`}
                                                                    onClick={ ()=>{ this.getExpiredFiles() } }
                                                                    aria-expanded="false" aria-controls="collapseOne">
                                                                    <i className="flaticon2-plus mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>
                                                                    <i className="flaticon2-line mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>{lang.get('messages.historial')}</button>
                                                            <div className="pr-4 font-weight-bolder">
                                                            </div>
                                                        </div>
                                                    <div id={`caducos`} className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                        <div className="pt-10 pb-10">
                                                        { this.state.expired.length == 0 &&
                                                            <h5 className="text-muted text-center">
                                                                {lang.get('messages.el_expediente_no_cuenta_con_documentos_en_el_historial')}
                                                            </h5>
                                                        }
                                                        { this.state.expired.length > 0 &&
                                                            <table className="table table-borderless m-0 table-valign">
                                                                <thead>
                                                                    <tr>
                                                                        <td colSpan={2} >{lang.get('messages.documento')}</td>
                                                                        <td>{lang.get('messages.formato')}</td>
                                                                        <td>{lang.get('messages.recurrencia')}</td>
                                                                        <td>{lang.get('messages.expiracion')}</td>
                                                                        <td></td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                { this.state.expired.map((d, i) => {
                                                                return <tr key={d.id}>
                                                                        <td><input type="checkbox"  id={d.id}   onChange={e => this.handleCheckboxExpiredChange(e)} checked={this.state.expiredCheckedFiles.includes(d.id.toString())}    /></td>
                                                                        <td className="d-flex gap-1" ><img src={"/assets/img/" + window.getMimeSVG(d.file.extension!=undefined && d.file.extension.length>0 ? d.file.extension : d.file.path)}/>
                                                                        <b>{d.file.title}</b>
                                                                        </td>
                                                                        <td>{
                                                                            d.document.mimes.map((mime, i, {length}) => {
                                                                                if (length - 1 === i) {
                                                                                    return mime.mime.toUpperCase()
                                                                                } else {
                                                                                    return mime.mime.toUpperCase() + ', '
                                                                                }
                                                                            })
                                                                        }</td>
                                                                        <td>
                                                                            {d.document.frequency == 'once' &&
                                                                                <b>{lang.get('messages.unico')}</b>
                                                                            }
                                                                            {d.document.frequency != 'once' &&
                                                                                <b>{lang.get('messages.recurrente')}</b>
                                                                            }
                                                                        </td>
                                                                        <td>{ (d.expiration_date != null ? moment(d.expiration_date).format('YYYY-MM-DD') : null)  }</td>
                                                                        <td className="text-right">
                                                                            <a className="btn btn-xs btn-icon btn-light-secondary mr-4"
                                                                                href={"/files/"  }
                                                                                target="_blank" download
                                                                            >
                                                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                })}
                                                                </tbody>
                                                            </table>
                                                            }
                                                            {this.state.expiredTotal > this.state.maxRecords  &&
                                                            <SimplePagination
                                                                    updateCurrentPage={this.updateCurrentExpiredPage}
                                                                    currentPage={this.state.expiredPage}
                                                                    totalFiles={this.state.expiredTotal}
                                                                    split={this.state.maxRecords} />}
                                                        </div>
                                                    </div>
                                                    </>}
                                                <div className="d-flex align-items-right gap-1 justify-content-end mt-1">
                                                <button className="btn btn-secondary" onClick={ ()=> this.back()}>{lang.get('messages.regresar')}</button>
                                                <button className="btn btn-primary" disabled={this.state.valid} onClick={ ()=> this.save()}>{lang.get('messages.guardar')}</button>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                    }
                </div>
            </div>
            </>
        );
    }
}

export default ShareDocuments;

if (document.getElementById('ShareDocuments')) {
    ReactDOM.render(<ShareDocuments />, document.getElementById('ShareDocuments'));
}
